export default __webpack_public_path__ + "static/media/c4.e10d74df.jpg";